import { memo } from 'react';
import { Stack, Image, Text, Button } from '@chakra-ui/react';
import { PencilSimpleLine } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';

import meetingNotStartedImage from '@/assets/image/job-created.svg';
import { Screening } from '@/types/Screening';

interface ScreeningScheduledProps {
  screening: Screening;
  onEditScreening: (screening: Screening) => void;
}

const ScreeningScheduled = memo(({ screening }: ScreeningScheduledProps) => {
  const navigate = useNavigate();

  return (
    <Stack align="center" mt="64px" mb="32px">
      <Image w="210px" h="210px" src={meetingNotStartedImage} alt="Empty Interview" mb="60px" />
      <Text fontSize="24px" fontWeight="bold" color="neutrals.800" mb="8px">
        Screening Sent to Candidate
      </Text>
      <Text fontSize="18px" color="neutrals.500" mb="24px">
        The deadline is on{' '}
        {new Date(screening.deadline * 1000).toLocaleTimeString('default', {
          weekday: 'short',
          month: 'long',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        })}
        .
      </Text>
      <Button
        color="neutrals.0"
        bg="primary.900"
        borderRadius="8px"
        fontWeight="semibold"
        fontSize="14px"
        p="10px 24px"
        _hover={{ bg: 'primary.700' }}
        aria-label="Edit interview"
        onClick={() => navigate(`/interview/agent/update/${screening.screening_id}`)}
      >
        Edit Meeting Details
        <PencilSimpleLine size={24} aria-hidden="true" />
      </Button>
    </Stack>
  );
});

ScreeningScheduled.displayName = 'ScreeningScheduled';

export default ScreeningScheduled;
